import { render, staticRenderFns } from "./CreateOrEditCategoryForm.vue?vue&type=template&id=0e83108a&"
import script from "./CreateOrEditCategoryForm.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports